export const yesNoOptions = [
    {
        label:  'Ja',
        value: true,
    },
    {
        label: 'Nein',
        value: false
    }
]

export const scrollToFirstError = () => {
    setTimeout(() => {
        const elErrorMessages = document.getElementsByClassName("text-[#dc2626]")

        window.scroll({
            top: elErrorMessages[0].getBoundingClientRect().top + window.scrollY - 100,
            behavior: 'smooth'
        });
    }, 100)
}
